(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(e){if(e.target.matches('[data-variant]')){const parent=e.target.closest('[data-product]');if(parent)parent.querySelector('[data-price]').textContent=e.target.selectedOptions[0].dataset.price;}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-support"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){const b=e.target.closest('[data-pad]');if(!b)return;const s=b.closest('.support');s.querySelectorAll('[data-pad]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));s.querySelector('.pad-output').textContent=b.dataset.pad;});
  } catch(e) { console.error(e); }
})();
})();
